// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e41d9651","455":"9ebb5657","977":"80b1100a"}[chunkId] + ".chunk.js";
};